import toast from 'react-hot-toast';

// Toasts modernes style Fideliz (inspiré Vercel/Linear)
export const showToast = {
  success: (message) => {
    toast.success(message, {
      duration: 4000,
      position: 'top-center',
      style: {
        background: '#F0FEE1',
        color: '#166534',
        padding: '16px',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '500',
        border: '1px solid #BBF7D0',
      },
      iconTheme: {
        primary: '#22C55E',
        secondary: '#F0FEE1',
      },
    });
  },

  error: (message) => {
    toast.error(message, {
      duration: 5000,
      position: 'top-center',
      style: {
        background: '#FEF2F2',
        color: '#991B1B',
        padding: '16px',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '500',
        border: '1px solid #FECACA',
      },
      iconTheme: {
        primary: '#EF4444',
        secondary: '#FEF2F2',
      },
    });
  },

  loading: (message) => {
    return toast.loading(message, {
      position: 'top-center',
      style: {
        background: '#EEF9FF',
        color: '#0068FE',
        padding: '16px',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '500',
        border: '1px solid #D4F1FF',
      },
    });
  },

  promise: (promise, messages) => {
    return toast.promise(
      promise,
      {
        loading: messages.loading || 'Chargement...',
        success: messages.success || 'Succès !',
        error: messages.error || 'Erreur',
      },
      {
        position: 'top-center',
        style: {
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: '500',
          padding: '16px',
        },
        success: {
          style: {
            background: '#F0FEE1',
            color: '#166534',
            border: '1px solid #BBF7D0',
          },
          iconTheme: {
            primary: '#22C55E',
            secondary: '#F0FEE1',
          },
        },
        error: {
          style: {
            background: '#FEF2F2',
            color: '#991B1B',
            border: '1px solid #FECACA',
          },
          iconTheme: {
            primary: '#EF4444',
            secondary: '#FEF2F2',
          },
        },
      }
    );
  },
};

